/** Removes legacy fixture annotations while preserving actual operator names. */
export function operatorDisplayName(name: string): string {
  const fixture = /^DEMO • ([^/]+?) \/ [^/]+$/u.exec(name);
  return fixture?.[1].trim() ?? name;
}
